// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-tsx" + "-" + "b29485603ed2798e9d74" + ".js";
};